import { render, staticRenderFns } from "./Consultas.vue?vue&type=template&id=8335f048&scoped=true&"
import script from "./Consultas.vue?vue&type=script&lang=js&"
export * from "./Consultas.vue?vue&type=script&lang=js&"
import style0 from "./Consultas.vue?vue&type=style&index=0&id=8335f048&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8335f048",
  null
  
)

export default component.exports